import { Component, inject } from '@angular/core';
import { TractorService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  TractorCreateDto,
  TractorDto,
  TractorExcelDownloadDto,
  TractorUpdateDto,
} from '../proxy/general/dtos/tractor';
import { TRACTOR_CONFIG, TRACTOR_FIELDS } from './tractor.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tractor',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, TractorService, ConfirmationService],
  templateUrl: './tractor.html',
  styleUrl: './tractor.scss',
})
export class Tractor extends BaseHierarchicalCrudComponent<
  TractorDto,
  TractorCreateDto,
  TractorUpdateDto,
  TractorExcelDownloadDto
> {
  service = inject(TractorService);
  config = TRACTOR_CONFIG;
  fields = TRACTOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractorDto): TractorUpdateDto {
    return {
      hasFlowMeter: data.hasFlowMeter,
      hasHighClearance: data.hasHighClearance,
      teoricalConsumption: data.teoricalConsumption,
      horsePower: data.horsePower,
      machineId: data.machineId,
      tractorCategoryId: data.tractorCategoryId,
      tractorTypeId: data.tractorTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Tractor';
  }
}
